import React from 'react';
import NumberFormat from 'react-number-format';
import { Controller } from 'react-hook-form';
const NumberInput2 = ({
  placeholder = '',
  labelClass = 'label-control',
  inputClass = 'form-control input-sm',
  //wrapperClass = 'form-group',
  inputWrapClass = 'col-md-8',
  labelText = '',
  starRed = '',
  inputProps = {},
  error,
}) => {
  return (
    <>
      <label className={labelClass}>
        {labelText} <span className="canh-bao-red">{starRed}</span>
      </label>
      <div className={inputWrapClass}>
        <Controller
          // as={NumberFormat}
          thousandSeparator
          prefix={''}
          name={inputProps.name}
          className={inputClass}
          control={inputProps.control}
          onChange={inputProps.onChange}
          value={inputProps.value}
          placeholder={placeholder}
          rules={inputProps.rules}
          defaultValue={inputProps.value}
          disabled={inputProps.disabled}
          readOnly={inputProps.readOnly}
          render={(props) => (
            <NumberFormat
              {...props}
              onValueChange={(value) => {
                props.onChange(value);
                inputProps.onChange(value);
              }}
              className={inputClass}
              thousandSeparator
              readOnly={inputProps.readOnly}
              value={inputProps.value}
              //isAllowed = {false}
            />
          )}
        />
        {error && <span className="canh-bao-red">{error.message}</span>}
      </div>
    </>
  );
};
export default NumberInput2;
